export const materialIconStyles = [
  '',
  '-outlined',
  '-round',
  '-tow-tone',
  '-sharp',
];
